// Updates the current storefront bundle's sent-email notice without loading a second viewer bundle.
(() => {
  const oldSuccess = 'Build link sent. Check your email.';
  const successLines = [
    ['strong', 'Success!'],
    ['span', 'Please check your email.'],
    ['span', 'Your build link may land in your spam or junk folder, so please check there too.'],
  ];

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('.ds-build-email-form')) return;
    const status = form.parentElement?.querySelector(':scope > [role="status"]');
    if (!status) return;
    status.classList.remove('ds-build-email-success');

    const observer = new MutationObserver(() => {
      const message = status.textContent.trim();
      if (!message) return;
      observer.disconnect();
      if (message !== oldSuccess) return;
      status.replaceChildren(...successLines.map(([tag, text]) => {
        const line = document.createElement(tag);
        line.textContent = text;
        return line;
      }));
      status.classList.add('ds-build-email-success');
    });
    observer.observe(status, { childList: true, characterData: true, subtree: true });
    setTimeout(() => observer.disconnect(), 30000);
  }, true);
})();
